import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {FormBuilder, FormGroup, Validators, FormControl, ValidationErrors} from "@angular/forms";
import {Observer, Observable} from 'rxjs';
import {CacheService} from "@delon/cache";

@Component({
  selector: 'app-app-apps-edit',
  templateUrl: './edit.component.html',
})
export class AppAppsEditComponent implements OnInit {
  record: any = {};
  i: any;
  form: FormGroup;
  stateList = this.cacheService.get(`api/dict/type/enableState`);
  typeAppList = this.cacheService.get(`api/dict/type/typeApp`);
  authTypeList = this.cacheService.get(`api/dict/type/authType`);

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public http: _HttpClient,
    private fb: FormBuilder,
    private cacheService: CacheService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      appId: [null, []],
      appName: [null, [Validators.required], [this.appNameAsyncValidator]],
      typeApp: [null, [Validators.required]],
      typeAuth: [null, [Validators.required]],
      remark: [null, []],
      createDate:[null, []],
      flagIp: [0, []],
      flagLLog: [0, []],
      flagLogOpt: [0, []],
      status: [1, [Validators.required]],
      // rsvn: [null, [Validators.required]],
    });
    if (!this.record.appId) {
      return;
    }

    this.http.get(`api/v1/sysrRegisterApp/${this.record.appId}`).subscribe(res => {
      this.form.patchValue(res);
      this.i = res;
    });
  }

  compareNumStr(c1: any, c2: any): boolean {
    return c1 == c2;
  }

  appNameAsyncValidator = (control: FormControl) =>
    Observable.create((observer: Observer<ValidationErrors>) => {
      if (!control.value) {
        observer.next(null);
        observer.complete();
        return;
      }
      this.http.get(`api/v1/sysrRegisterApp/checkAppName`,
        {appName: control.value, appId: this.record.appId}).subscribe((res:any)=> {
        if (res.valid === true) {
          observer.next(null);
        } else {
          observer.next({ error: true, duplicated: true });
        }
        observer.complete();
      });
    });

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    if (!this.record.appId) {
      //æ°å¢
      this.http.post(`api/v1/sysrRegisterApp`, this.form.value).subscribe(res => {
        this.msgSrv.success('ä¿å­æå');
        this.modal.close(true);
      });
      return;
    }
    //ä¿®æ¹
    this.http.put(`api/v1/sysrRegisterApp/${this.record.appId}`, this.form.value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
